export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10958.dd9e9a9d.jpg";